export enum UserPermission {
  COMPOSITE_PURCHASE_DOC = 'CompositePurchaseDoc',
}


// WEBPACK FOOTER //
// ./src/constants/UserPermission.ts